import React from "react";
import { Col, Form, Input, Row, Tabs } from "antd";
import { DeltaStatic } from "quill";
import styles from "./index.module.scss";
import { SaveOfferContent } from "../../../../../types/model/saveOffer";
import { isDeltaEmpty } from "../../../../../utils/richTextEditor";
import { DESCRIPTION_MAX_LENGTH } from "../../../../products/Disclosure/common";
import { EComRichTextInput } from "../../../../../components/EComRichText";
import { LocaleType } from "../../../../../utils/locale";

interface SaveOfferDetailsProps {
  contents: SaveOfferContent[];
  setContents: (contents: SaveOfferContent[]) => void;
}

export function SaveOfferTitleAndDescription({ contents, setContents }: SaveOfferDetailsProps) {
  const updateTitle = (value: string, locale: LocaleType) => {
    const updatedContents = contents.map((content) =>
      content.locale === locale ? { ...content, title: value } : content
    );
    setContents(updatedContents);
  };

  const updateDescription = (value: DeltaStatic, locale: LocaleType) => {
    const updatedContents = contents.map((content) =>
      content.locale === locale ? { ...content, description: value } : content
    );
    setContents(updatedContents);
  };

  return (
    <>
      <div className={styles.subtitle}>
        <span>Save offer details</span>
      </div>
      <Col className={styles.tabCardContainer} span={18}>
        <Tabs type="card">
          {contents.map((item: SaveOfferContent) => (
            <Tabs.TabPane tab={item.label} key={item.key}>
              <Row>
                <Col span={18}>
                  <Form.Item
                    label="Save offer title"
                    name={`${item.locale}Title`}
                    rules={[{ type: "string", max: 100, required: item.required }]}
                  >
                    <Input onChange={(e) => updateTitle(e.target.value, item.locale)} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item
                    style={{ margin: 0 }}
                    label="Save offer description"
                    name={`${item.locale}Description`}
                    rules={[
                      {
                        required: item.required,
                        transform: (value) => (isDeltaEmpty(value) ? "" : JSON.stringify(value)),
                        type: "string",
                        max: DESCRIPTION_MAX_LENGTH,
                      },
                    ]}
                  >
                    <EComRichTextInput
                      bounds={item.key}
                      editable={true}
                      value={item.description}
                      onChange={(value) => updateDescription(value, item.locale)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Tabs.TabPane>
          ))}
        </Tabs>
      </Col>
    </>
  );
}
